const Staff: React.FunctionComponent = function () {
  return <div>Staff</div>;
};

export default Staff;
